<template>
  <div class="rew19_aro_wrap shop">
  <div class="rew19_contents_inner">
    <h2 class="rew19_second_title">나의 정기구매</h2>
    <h3 class="rew19_third_title">주문 정보</h3>
    <ul class="rew19_underline_list">
      <li class="type1">
        <em>정기구매 주문번호</em>
        <span class="substance">
          <span class="gep_btnRight">
            {{viewData.aro_no}}
          </span>
            <a @click="openAdpTransformDialog" class="rew19_btn_border adpBtn" v-if="isShowAdpBtn">타입 변경</a>
        </span>
      </li>
      <li class="type1">
          <em>주문명칭</em>
          <span class="substance">
              <span class="gep_btnRight">{{viewData.aroTag}}</span> <a @click="openAroNameChangeDialog(viewData.aro_no, viewData.aroTag)" class="rew19_btn_border">변경</a>
          </span>
      </li>
      <li class="type1">
          <em v-if="paymentCase == '1' || paymentCase == '2'">배송일</em>
          <em v-if="paymentCase != '1' && paymentCase != '2'">자동 결제일</em>
          <span class="substance">
              <span class="gep_btnRight" v-if="paymentCase == '1' || paymentCase == '2'">이번달 배송일 {{viewData.delivery_day}}일
                <span v-if="viewData.chdelivery_day != null && viewData.chdelivery_day != '' && paymentCase != '2'"> (다음달 배송일 {{viewData.chdelivery_day}}일로 변경예정)</span>
                <span v-if="viewData.addPaymentType === 'G'"> (이번달 건너뛰기 적용중입니다.)</span>
              </span>
              <span class="gep_btnRight" v-if="paymentCase != '1' && paymentCase != '2'">이번달 결제일
                <span v-if="paymentCase == '3'">{{parseInt(viewData.delivery_day, 10)-7}}</span>
                <span v-if="paymentCase == '4'">{{viewData.delivery_day}}</span>
                일
                <span v-if="viewData.chdelivery_day != null && viewData.chdelivery_day != '' && paymentCase == '3'"> (다음달 결제일 {{parseInt(viewData.chdelivery_day, 10)-7}}일로 변경예정)</span>
                <span v-if="viewData.chdelivery_day != null && viewData.chdelivery_day != '' && paymentCase == '4'"> (다음달 결제일 {{viewData.chdelivery_day}}일로 변경예정)</span>
                <span v-if="viewData.addPaymentType === 'G'"> (이번달 건너뛰기 적용중입니다.)</span>
              </span>
              <a class="rew19_btn_border" @click="openChangeDeliveryDateDialog">변경</a>
          </span>
      </li>
      <li class="type1">
          <em v-if="paymentCase == '1' || paymentCase == '2'">결제일</em>
          <em v-if="paymentCase != '1' && paymentCase != '2'">배송일</em>
          <span class="substance" v-if="paymentCase == '1' || paymentCase == '2'">
              {{viewData.pay_day}}일
          </span>
          <span class="substance" v-if="paymentCase != '1' && paymentCase != '2'">
              결제일 다음날부터 3일 이내 배송(영업일 기준)
          </span>
      </li>
      <li class="type1">
          <em>결제방법</em>
          <span class="substance">
            <span class="gep_btnRight" v-if='$nvl(viewData.payment_typ,"") == AroConst.VALUE_payment_type_credit_card'>{{viewData.payment_info}}
              <span>{{viewData.inst_month == '00' ? '일시불' : viewData.inst_month + '개월'}}</span>
            </span>
            <span class="gep_btnRight" v-if='$nvl(viewData.payment_typ,"") == AroConst.VALUE_payment_type_account_transfer'>{{$getContentPaymentType(viewData.payment_typ)}}</span>
             <a @click="openPaymentInfoDialog" class="rew19_btn_border">변경</a>
          </span>
      </li>
      <li class="type1">
          <em>할인율</em>
          <span class="substance" v-if="viewData.saving_percentage != '15'">
              {{viewData.saving_percentage}}%
          </span>
        <span class="substance" v-if="viewData.saving_percentage == '15'">
              약 &nbsp;{{viewData.saving_percentage}}%
          </span>
      </li>
      <li class="type1">
          <em>진행회차</em>
          <span class="substance">
              총{{viewData.payment_count}}회
          </span>
      </li>
      <li class="type1">
        <em>제품명세 및 수령증</em>
        <span class="substance">
          <span class="gep_btnRight">{{viewData.wholesale_receipt == 'Y' ? '도매용' : '소매용' }}</span>
          <a @click="openChangeReceiptDialog" class="rew19_btn_border">변경</a>
        </span>
      </li>
      <li class="type1">
        <em>전자거래명세서 수신</em>
        <span class="substance">
          <span class="gep_btnRight">{{viewData.e_transaction_type == '1' ? '제품 수령인만 수신' : '제품 수령인 및 본인(회원정보 등록 연락처) 모두 수신' }}</span>
          <a @click="openChangeElectronicStatementDialog" class="rew19_btn_border">변경</a>
        </span>
      </li>
    </ul>
    <h3 class="rew19_third_title">배송 정보
        <a @click="openChangeShipInfoDialog" class="rew19_btn_T1 inthird" onclick="return false;"><span>변경</span></a>
    </h3>
    <ul class="rew19_underline_list">
      <li class="type1">
        <em>수령인</em>
        <span class="substance">
            {{viewData.ship_name}}
        </span>
      </li>
      <li class="type1">
        <em>전화번호</em>
        <span class="substance">
            {{viewData.ship_tel}}
        </span>
      </li>
      <li class="type1">
        <em>핸드폰 번호</em>
        <span class="substance">
            {{viewData.ship_phone}}
        </span>
      </li>
      <li class="type1">
        <em>주소</em>
        <span class="substance">
            ({{viewData.postal_cd1}}{{viewData.postal_cd2}}) {{viewData.home_addr}} {{viewData.home_addr_detail}}
        </span>
      </li>
    </ul>
    <h3 class="rew19_third_title">주문 상품
        <a @click="openProductChangeDialog" class="rew19_btn_T1 inthird" v-if="viewData.USPAN_YN != 'Y' && viewData.META_YN != 'Y'"><span>변경</span></a>
    </h3>
    <div class="rew19_payment_content">


        <div class="rew19_flex_box" v-for="(pd) in viewData.pd_list" :key="pd.pd_id">

          <div class="rew19_payment_list__img">
              <img :src="pd.pd_img_url1" alt="" title=""
                   onError="imageError(this)" data-error-cnt="0"
              />
          </div>

          <div class="rew19_payment_list__infor">
              <h4>{{pd.pd_name_kr}}</h4>
              <ul class="rew19_payment_items flex">
                  <li>
                      <span class="rew19_point rew19_gDetail">{{$fmt.WON(pd.pd_amt)}} 원 / {{pd.pd_count}}개</span>
                  </li>
                  <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                      <span class="rew19_gDetail"><em>SV</em> {{$fmt.PV(pd.pv)}}</span>
                  </li>
                  <li v-if="getMemberType() == 'DIST'">
                      <span class="rew19_gDetail"><em>CSV</em>{{$fmt.PV(pd.cv)}}</span>
                  </li>
<!--                  <li v-if="getMemberType() == 'DIST'">-->
<!--                      <span class="rew19_gDetail"><em>SB</em>{{$fmt.PV(pd.sb)}}</span>-->
<!--                  </li>-->
                  <li>
                      <span class="rew19_gDetail"><em>합계</em> {{$fmt.WON(pd.total_amt)}} 원</span>
                  </li>
              </ul>
              <ul class="rew19_payment_items flex add" v-for="(agm, idx) in pd.agm_info" :key="idx">
                  <li>
                      <span class="rew19_gDetail"><em>이름</em>{{agm.agm_name}}</span>
                  </li>
                  <li>
                      <span class="rew19_gDetail"><em>코드</em>{{agm.agm_code}}</span>
                  </li>
                  <li>
                      <span class="rew19_gDetail"><em>코드별명</em>{{agm.agm_detail}}</span>
                  </li>
              </ul>
          </div>

        </div>


    </div>

    <div class="rew19_payment_bottom">

        <ul class="rew19_payList">
            <li v-if="getMemberType() == 'DIST' || getMemberType() == 'PREF' || getMemberType() == 'GENERAL'">
                <em class="rew19_payTitle">합계 SV</em>
                <span class="rew19_payDetail">
                    {{$fmt.PV(viewData.total_pv)}}
                </span>
            </li>
            <li v-if="getMemberType() == 'DIST'">
                <em class="rew19_payTitle">합계 CSV</em>
                <span class="rew19_payDetail">
                    {{$fmt.PV(viewData.total_cv)}}
                </span>
            </li>
<!--            <li v-if="isShowTotalSb">-->
<!--                <em class="rew19_payTitle">합계 SB</em>-->
<!--                <span class="rew19_payDetail">-->
<!--                    {{$fmt.PV(viewData.total_sb)}}-->
<!--                </span>-->
<!--            </li>-->
            <li v-bind:class="{lastLine : getMemberType() == 'DIST'}">
                <em class="rew19_payTitle">주문금액</em>
                <span class="rew19_payDetail rew19_point">
                        <strong>{{$fmt.WON(viewData.payment_amt)}} 원</strong>
                </span>
            </li>
        </ul>

    </div>


    <div class="rew19_responsive_btns gepTaye1">
  <!--
        <a href="#" class="rew19-btn-border">이전 주문 건너뛰기</a>
        <a href="#" class="rew19-btn-normal">철회하기</a>
        <a href="#" class="rew19-btn-border">목록</a>
  -->
        <a @click="onClickGrace" class="rew19-btn-border" v-if="viewData.graceCoupon >= 1 && viewData.addPaymentType == '' && $usingGraceFunction">이번 주문 건너뛰기</a>
        <a @click="onClickCancelGrace" class="rew19-btn-border" v-if="viewData.addPaymentType == 'G' && $usingGraceFunction">건너뛰기 취소</a>
        <a @click="onClickCancel" class="rew19-btn-normal">철회하기</a>
        <router-link :to="{name:'aroList'}" class="rew19-btn-border">목록</router-link>
  <!--
        <a href="#" class="rew19-btn-normal">철회하기</a>
        <a href="#" class="rew19-btn-border">목록</a>
  -->
    </div>
  </div><!--rew19_contents_inner-->


  <product-change-dialog
    :show="productChangeDialogShow"
    :title="'나의 정기구매 주문 상품 변경'"
    :memberId="getMemberId()"
    :prodAppendYn = "prodAppendYn"
    ref="productChangeDialog"
    @close="productChange"
  ></product-change-dialog>


  <delivery-date-dialog
      :show="deliveryDateDialogShow"
      @close="changeDeliveryDate"
      ref="deliveryDateDialog"
    ></delivery-date-dialog>

    <payment-info-dialog
      :show="paymentInfoDialogShow"
      :mode="paymentInfoDialog.mode"
      :showCardTerm="true"
      :showInstMonth="true"
      :isHidden="isHidden"
      :isHidden2="isHidden2"
      @close="changePaymentInfo"
      ref="paymentInfoDialog"
    ></payment-info-dialog>

    <ship-info-dialog
      :show="shipInfoDialogShow"
      @close="changeShipInfo"
      ref="shipInfoDialog"
    ></ship-info-dialog>

    <aro-name-change-dialog
      :show="aroNameChangeDialogShow"
      ref="aroNameChangeDialog"
      @close="aroNameChange"
    ></aro-name-change-dialog>

    <change-receipt-dialog
      :show="changeReceiptDialogShow"
      ref="changeReceiptDialog"
      @close="changeReceipt"
    ></change-receipt-dialog>

    <change-electronic-statement-dialog
      :show="changeElectronicStatementDialogShow"
      ref="changeElectronicStatementDialog"
      @close="changeElectronicStatement"
    ></change-electronic-statement-dialog>

    <adp-transform-dialog
      :show="adpTransformDialogShow"
      ref="adpTransformDialog"
      @close="adpTransform"
    ></adp-transform-dialog>
</div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import DeliveryDateDialog from '@/components/popup/DeliveryDateDialog';
import PaymentInfoDialog from '@/components/popup/PaymentInfoDialog';
import ShipInfoDialog from '@/components/popup/ShipInfoDialog';
import ProductChangeDialog from '@/components/popup/ProductChangeDialog';
import AroNameChangeDialog from '@/components/popup/aroNameChangeDialog';
import ChangeReceiptDialog from '@/components/popup/changeReceiptDialog';
import ChangeElectronicStatementDialog from "@/components/popup/ChangeElectronicStatementDialog";
import AdpTransformDialog from '@/components/popup/AdpTransformDialog';

import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";
import * as Crypto from '@/utils/cryptoUtil';

import DF from 'dateformat';

export default {
  name: "AroDetail",
  extends: AroBase,
  components: {
    DeliveryDateDialog,
    PaymentInfoDialog,
    ShipInfoDialog,
    ProductChangeDialog,
    AroNameChangeDialog,
    ChangeReceiptDialog,
    ChangeElectronicStatementDialog,
    AdpTransformDialog
  },
  computed: {
    isNuskinChannel : function() {
       return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    }
  },
  props:{
    aro_no: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isHidden: false,
      isHidden2: false,
      //View Data
      viewData : {
        pd_list : []
      },
      params : {},

      //popup
      //배송일 변경
      deliveryDateDialogShow : false,
      deliveryDateDialog : {},

      //결제정보
      paymentInfoDialogShow : false,
      paymentInfoDialog : {},

      //배송지 변경
      shipInfoDialogShow : false,
      shipInfoDialog : {},

      //주문상품 변경
      productChangeDialogShow : false,
      productChangeDialog : {},

      // aro 장바구니 이름 변경
      aroNameChangeDialogShow : false,
      aroNameChangeDialog : {},

      // 도매용 변경
      changeReceiptDialogShow : false,
      changeReceiptDialog : {},

      // 전자거래명세서 수신자 변경
      changeElectronicStatementDialogShow : false,
      changeElectronicStatementDialog : {},

       // adp 구매 건 전환 신청
      adpTransformDialogShow : false,
      adpTransformDialog : {},
      isShowAdpBtn : false,

      testText : "",
      // isShowTotalSb : false,
      prodAppendYn : true,

      paymentCase : "",

    };
  },
  created() {
  },
  mounted() {
    let _this = this;

    _this.loadDetail();
    _this.autoPaymentDate();

    // if(_this.getMemberType() == "DIST" && _this.getMemberTitle() >= 40){
    //   _this.isShowTotalSb = true;
    // }
  },
  methods: {
    updateNow() {
      const now = new Date();
      let ckTime = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;

      if (this.$december1st <= parseInt(ckTime)) {
        this.isHidden = true; // 일정 시간 경과
      } else {
        this.isHidden = false; // 경과하지 않음
      }

      if (this.$january1st <= parseInt(ckTime)) {
        this.isHidden2 = true; // 일정 시간 경과
      } else {
        this.isHidden2 = false; // 경과하지 않음
      }
    },
    /**
     * JQuery UI
     */
    initUI(){

    },

    /**
     * API Request
     */
    //나의 에이지락 미 정보 가져오기
    apiGetAroDetail(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro_detail`, {
        params: {
          aro_no : _this.aro_no
        }
      });
    },

    //배송일 변경처리
    apiChangeDeliveryDate(deliveryDay, nowChDay, nextChDay){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_delivery_date`, {
        params: {
          aro_no : _this.aro_no,
          delivery_day : deliveryDay,
          nowChDay: nowChDay,
          nextChDay: nextChDay
        }
      });
    },

    //배송지 변경처리
    apiChangeDelivery(addrInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_delivery`, {
        params: {
          aro_no : _this.aro_no,
          ship_name : addrInfo.shipName,
          ship_tel : addrInfo.phoneNumber,
          ship_phone: addrInfo.phoneNumber,
          postal_cd : addrInfo.zipCode,
          home_addr: addrInfo.firstAddress,
          home_addr_detail: addrInfo.lastAddress,
          wholesale_receipt : _this.viewData.wholesale_receipt
        }
      });
    },

    //결제정보 변경처리
    apiChangePayment(paymentInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_payment`, {
        params: {
          aro_no : _this.aro_no,
          ...paymentInfo
        }
      });
    },

    // 주문상품 변경
    apiChangeProduct(pd_add_list){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/change_product`, {
        params: {
          aro_no : _this.aro_no,
          pd_add_list : JSON.stringify(pd_add_list)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //ARO 변경 가능 여부 체크
    apiCheckAroModifyStatus : function(aro_no){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/modify_status`, {
        params: {
          adpNo : aro_no
        }
      });
    },

    // aro 장바구니 이름 변경
    apiAroPutTags : function(aro_no, aro_tag){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_tags`, {
          params : {
            adpNo : aro_no,
            aroTag : aro_tag
          }
      });
    },

    // 도매용 변경
    apiAroPutReceipt: function(receiptInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_receipt`, {
          params : {
            ...receiptInfo
          }
      });
    },

    // 전자거래명세서 수신자 변경
    apiAroElectronicStatement: function(e_transaction_type,aro_no){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_transaction`, {
        params : {
          aro_no : aro_no,
          ... e_transaction_type
        }
      });
    },

    // 건너뛰기
    apiAroPutGrace : function(graceInfo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_grace`, {
          params : {
            ...graceInfo
          }
      });
    },

    // ADP 변경 가능 기간 체크
    apiAdpCheckDay : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/adp/isCheckAdpDay`, {
          params : {}
      });
    },

    apiAutoPaymentDate : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/autoPaymentDate`, {
        params: {}
      });
    },

    /**
     * Local function
     */
    //데이터 로드
    loadDetail(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetAroDetail().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {

          if(res.data.payment_typ == _this.AroConst.VALUE_payment_type_credit_card){
            _this.viewData = {
              ...res.data
              ,cardnumber : Crypto.replaceStringForCardNumber(res.data.ccard_no, res.data, _this.getMemberId())
            };
          }else{
            _this.viewData = {
              ...res.data
            };
          }

          if(_this.viewData.adp_type == 'ADP'){
            _this.adpCheckDay();
          }else{
            return null;
          }

        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    autoPaymentDate(){
      let _this = this;

      _this.apiAutoPaymentDate().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {

          if(res.data.result){
            _this.paymentCase = res.data.case
          }else{
            _this.paymentCase = "1";
          }

          return;

        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    autoPaymentDate(){
      let _this = this;

      _this.apiAutoPaymentDate().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {

          if(res.data.result){
            _this.paymentCase = res.data.case
          }else{
            _this.paymentCase = "1";
          }

          return;

        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }
      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //Open dialog 배송일 변경
    openChangeDeliveryDateDialog(){
      let _this = this;

      //pass data to dialog
      let aroData = _this.viewData;
      _this.deliveryDateDialog = {
        ..._this.deliveryDateDialog,
        delivery_day : aroData.delivery_day,
        delivery_days_current : aroData.delivery_days_current,
        delivery_days_next : aroData.delivery_days_next,
        chdelivery_day : aroData.chdelivery_day,
        paymentCase : _this.paymentCase
      };

      _this.$refs.deliveryDateDialog.initData(_this.deliveryDateDialog);
      _this.deliveryDateDialogShow = true;
    },

    //배송일 변경
    changeDeliveryDate(isOk, data){
      let _this = this;

      _this.deliveryDateDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      let aroData = _this.viewData;
      if(aroData.delivery_day == data.delivery_day_current &&
        aroData.delivery_day == data.delivery_day_next)
      { //변경할 필요가 없음
        _this.$dialogs.alert("배송일이 기존과 동일하여, 배송일을 변경하지 않았습니다.")
        .then(res => {});
        return;
      }

      //show loading
      _this.$showLoading();
      _this.apiCheckAroModifyStatus(_this.aro_no).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
            return _this.apiChangeDeliveryDate(aroData.delivery_day, data.delivery_day_current, data.delivery_day_next);
          }else{
            //ARO 변경 불가능한 경우
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
        }

      }).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("결제일 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //Open Dialog결제정보 변경
    openPaymentInfoDialog(){
      this.updateNow();
      let _this = this;

      //pass data to dialog
      _this.paymentInfoDialog = {
        //..._this.paymentInfoDialog,
        mode : 0, //신용카드, 계좌이체 모두
        paymentType : parseInt(_this.viewData.payment_typ, 10),
        card :{
          birth : _this.viewData.birth,
          cardnumber : _this.viewData.cardnumber,

          useTerm : _this.$aroApiBasePath + _this.AroConst.VALUE_ARO_CARD_USE_TERM_SHORT
        },
        account:{

        }
      };
      _this.$refs.paymentInfoDialog.setVisibility(_this.isHidden);
      _this.$refs.paymentInfoDialog.setVisibility2(_this.isHidden2);
      _this.$refs.paymentInfoDialog.initData(_this.paymentInfoDialog);
      _this.paymentInfoDialogShow = true;
    },

    //결제정보 변경
    changePaymentInfo(isOk, data){
      let _this = this;

      _this.paymentInfoDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      let paymentInfo = {
        payment_typ : data.paymentType
      };
      if(data.paymentType == 2){
        paymentInfo = {
          ...paymentInfo,
          birth_dt : data.card.birth,
          ccard_no : data.card.cardnumber,
          ccard_exp : data.card.expYY + data.card.expMM,
          passwd : data.card.pwd,
          inst_month : data.card.instMonth
        }
      }else if(data.paymentType == 3){
        paymentInfo = {
          ...paymentInfo,
          cms_no : data.account.cms_no,
          birth_dt : data.account.birth,
          receipt_no : data.account.receipt_no
        }
      }

      //show loading
      _this.$showLoading();
      _this.apiCheckAroModifyStatus(_this.aro_no).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
            return  _this.apiChangePayment(paymentInfo);
          }else{
            //ARO 변경 불가능한 경우
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
        }
      }).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("결제 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{

        //hide loading
        _this.$hideLoading();
      });
    },

    //Open dialog 배송 정보 변경
    openChangeShipInfoDialog(){
      let _this = this;

      //pass data to dialog
      _this.shipInfoDialog = {
        ..._this.shipInfoDialog,
        memberId : _this.getMemberId()
      };

      _this.$refs.shipInfoDialog.initData(_this.shipInfoDialog);
      _this.shipInfoDialogShow = true;
    },

    //배송 정보 변경
    changeShipInfo(isOk, data){
      let _this = this;

      _this.shipInfoDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      //show loading
      _this.$showLoading();
      _this.apiCheckAroModifyStatus(_this.aro_no).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
            return _this.apiChangeDelivery(data);
          }else{
            //ARO 변경 불가능한 경우
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
        }
      }).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("배송지 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //Open dialog 주문상품 변경
    openProductChangeDialog(){
      let _this = this;

      //pass data to dialog
      _this.productChangeDialog = {
        ..._this.productChangeDialog,
        pd_list : _this.viewData.pd_list,
        aro_payment_count : _this.viewData.aro_payment_count,
      };

      if(_this.viewData.prod_add_yn == 'N'){
        _this.prodAppendYn = false;
      }else{
        _this.prodAppendYn = true;
      }

      _this.$refs.productChangeDialog.initData(_this.productChangeDialog);
      _this.productChangeDialogShow = true;
    },

    //주문상품 변경
    productChange(isOk, data){
      let _this = this;

      _this.productChangeDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      // 상품 변경 불가능한 상품 비교 로직
      {
        let isChange = true;
        let original_pd_list = _this.viewData.pd_list;

        if(_this.viewData.prod_add_yn == 'N'){

          if(original_pd_list.length < data.length){
            isChange = false;
            _this.$dialogs.alert("상품 정보를 변경할 수 없는 정기구매 입니다.");
            return;
          }

          original_pd_list.filter(before => {
            data.filter(after => {
              if(before.pd_id == after.pd_id){
                if(before.pd_count != after.pd_count){
                  isChange = false;
                  return;
                }
              }
            });
          });

          if(!isChange){
            _this.$dialogs.alert("상품 정보를 변경할 수 없는 정기구매 입니다.");
            return;
          }
        }
      }

      let pd_add_list = [];
      for(var num in data){
        let item = {};
        item['pd_id'] = data[num].pd_id;
        item['pd_count'] = data[num].pd_count;
        if(data[num].agm_info != undefined){
          item['agm_info'] = data[num].agm_info;
        }
        pd_add_list.push(item);
      }

      _this.$showLoading();
      _this.apiCheckAroModifyStatus(_this.aro_no).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
            return _this.apiChangeProduct(pd_add_list);
          }else{
            //ARO 변경 불가능한 경우
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
        }

      }).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("제품 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    //철회하기
    onClickCancel(){
      let _this = this;

      _this.$router.push(`${_this.$aroBasePath}/aroCancel?aro_no=${_this.aro_no}`);
    },

    //Open dialog aro 장바구니 이름 변경
    openAroNameChangeDialog(aro_no, aro_tag){
      let _this = this;

      //pass data to dialog
      _this.aroNameChangeDialog = {
        ..._this.aroNameChangeDialog,
        aro_no : aro_no,
        aro_tag : aro_tag
      };

      _this.$refs.aroNameChangeDialog.initData(_this.aroNameChangeDialog);
      _this.aroNameChangeDialogShow = true;
    },

    // aro 장바구니 이름 변경
    aroNameChange(isOk, data){
      let _this = this;

      _this.aroNameChangeDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      _this.$showLoading();
      _this.apiAroPutTags(data.aro_no, data.aro_tag).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("장바구니 명칭을 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    },

    // 도매용 변경
    openChangeReceiptDialog(){
      let _this = this;

      //pass data to dialog
      _this.changeReceiptDialog = {
        ..._this.changeReceiptDialog,
        aro_no : _this.viewData.aro_no,
        wholesale_receipt : _this.viewData.wholesale_receipt
      };

      _this.$refs.changeReceiptDialog.initData(_this.changeReceiptDialog);
      _this.changeReceiptDialogShow = true;
    },

    changeReceipt(isOk, data){
      let _this = this;

      _this.changeReceiptDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      //show loading
      _this.$showLoading();
      _this.apiCheckAroModifyStatus(_this.aro_no).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
            return _this.apiAroPutReceipt(data);
          }else{
            //ARO 변경 불가능한 경우
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
        }

      }).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("제품명세 및 수령증 정보를 변경 하였습니다.")
          .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    // 전자거래명세서 수신자 변경
    openChangeElectronicStatementDialog(){
      let _this = this;

      //pass data to dialog
      _this.changeElectronicStatementDialog = {
        ..._this.changeElectronicStatementDialog,
        aro_no : _this.viewData.aro_no,
        e_transaction_type : _this.viewData.e_transaction_type
      };

      _this.$refs.changeElectronicStatementDialog.initData(_this.changeElectronicStatementDialog);
      _this.changeElectronicStatementDialogShow = true;
    },

    changeElectronicStatement(isOk, data){
      let _this = this;

      _this.changeElectronicStatementDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

      //show loading
      _this.$showLoading();
      _this.apiCheckAroModifyStatus(_this.aro_no).then((res)=>{
        if (res.status === 200 && res.data.status === "0000") {
          return _this.apiAroElectronicStatement(data,res.data.aro_no);
        }else{
          //ARO 변경 불가능한 경우
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
            .then(res => {});
          return null;
        }

      }).then(res=>{
        if (res.status === 200 && res.data.status === "0000") {
          _this.$dialogs.alert("전자거래명세서 수신자를 변경 하였습니다.")
            .then(res => {});

          _this.loadDetail();
          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
            .then(res => {});
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //건너뛰기
    onClickGrace(){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'확인'};
      let msg = `해당 주문을 건너뛰고 다음 달부터 다시 정기 배송합니다.<br/>계속 하시겠습니까?`;
      let graceInfo = {
        adpNo : _this.aro_no,
        graceUse : 'Y',
      }
      _this.$dialogs.confirm(msg, options).then(res=>{
        if(res.ok){
          _this.$showLoading();
          _this.apiAroPutGrace(graceInfo).then(res=>{

            if (res.status === 200 && res.data.status === "0000") {
              _this.$dialogs.alert("이번 주문을 건너뛰기 하였습니다.")
              .then(res => {});

              _this.loadDetail();
              return;
            }else{
              let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
              _this.$dialogs.alert(errMsg)
              .then(res => {});
            }

          }).catch((err)=>{
            console.error(err);
            _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
            .then(res => {});

          }).finally(()=>{
            //hide loading
            _this.$hideLoading();
          });
        }
      });
    },

    //건너뛰기 취소
    onClickCancelGrace(){
      let _this = this;

      const options = {cancelLabel: '취소', okLabel:'확인'};
      let msg = `이번 달 건너뛰기를 취소하면 이번 달 ${_this.viewData.delivery_day}일에 배송합니다.<br/>계속 하시겠습니까?`;
      let graceInfo = {
        adpNo : _this.aro_no,
        graceUse : 'N',
        targetYearMonth : _this.viewData.addPayTYMonth
      }

      _this.$dialogs.confirm(msg, options).then(res=>{
        if(res.ok){
          _this.$showLoading();
          _this.apiAroPutGrace(graceInfo).then(res=>{

            if (res.status === 200 && res.data.status === "0000") {
              _this.$dialogs.alert("이번 달 건너뛰기 취소 하였습니다.")
              .then(res => {});

              _this.loadDetail();
              return;
            }else{
              let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
              _this.$dialogs.alert(errMsg)
              .then(res => {});
            }

          }).catch((err)=>{
            console.error(err);
            _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
            .then(res => {});

          }).finally(()=>{
            //hide loading
            _this.$hideLoading();
          });
        }
      });
    },

    // ADP 전환 신청
    openAdpTransformDialog(){
      let _this = this;

      //pass data to dialog
      _this.adpTransformDialog = {
        adp_no : _this.viewData.aro_no
      };

      _this.$refs.adpTransformDialog.initData(_this.adpTransformDialog);
      _this.adpTransformDialogShow = true;
    },

    adpTransform(isOk, data){
      let _this = this;

      _this.adpTransformDialogShow = false;

      if(!isOk){
        //Do nothing
        return;
      }

    },

    adpCheckDay(){
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiAdpCheckDay().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          if(res.data.result){
            _this.isShowAdpBtn = true;
          }else{
            _this.isShowAdpBtn = false;
          }

          return;
        }else{
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {
            _this.isShowAdpBtn = false;
          });
        }

      }).catch((err)=>{
        console.error(err);
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
         _this.$hideLoading();
      });
    }

  }
}
</script>
<style>
a.rew19_btn_T1, a.rew19-btn-border, a.rew19-btn-normal{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/my/aro/detail.vue